import React, {Component} from "react"
import {Checkbox} from 'formsy-react-components'
import selected from "chai-enzyme/build/assertions/selected"
import {injectIntl} from "react-intl"


class WeekdayCheckboxGroup extends Component {

  constructor(){
    super()
    this.state = {

    }
  }

  componentWillMount() {
  }

  render() {

    const formatMessage = this.props.intl.formatMessage

    const options = [

      {
        value: 2,
        label: formatMessage({id:'monday'})
      },
      {
        value: 3,
        label: formatMessage({id:'tuesday'})
      },
      {
        value: 4,
        label: formatMessage({id:'wednesday'})
      },
      {
        value: 5,
        label: formatMessage({id:'thursday'})
      },
      {
        value: 6,
        label: formatMessage({id:'friday'})
      },
      {
        value: 7,
        label: formatMessage({id:'saturday'})
      },
      {
        value: 1,
        label: formatMessage({id:'sunday'})
      },

    ]

    return (
      <table className="full-width">
        <tr>
          {options.map(it=>(
            <td>
              <Checkbox
                onChange={(name,value)=>{
                  const delta = {}
                  delta[name] = value

                  const currentState = this.state
                  if(this.props.onChange){
                    const newState = Object.assign({}, currentState, delta)
                    const selected = Object.keys(newState).filter(k=>newState[k])
                    // console.log(selected)
                    this.props.onChange(this.props.name, selected)
                  }

                  this.setState(delta)
                }}
                name={`${it.value}`}
                value={`${it.value}`}
                label={it.label}
                />
            </td>
          ))}
        </tr>

      </table>
      /*<CheckboxGroup name={this.props.name}
              label=""
              type="inline"
              value={this.props.value?this.props.value:[]}
              options={options}
              required={this.props.required}
              {...this.props}
      >
      </CheckboxGroup>*/
    )
  }
}

export default injectIntl(WeekdayCheckboxGroup)



// WEBPACK FOOTER //
// ./src/routes/cogoland/component/WeekdayCheckboxGroup.js